export const setProductSearch = (state, param) => {
  state.search = param
}

export const setProducts = (state, param) => {
  state.result.list = param.data.data.products
  state.result.pricingModels = param.data.data.pricing_models
  state.result.count = param.data.data.products_count
  state.result = {...state.result, 'productUnderCategoryCount': param.data.data.product_under_category_counts}
  state.result.page = param.data.data.page.number
  state.result.translations = param.data.data.translations
}

export const setProductsUnderCategory = (state, param) => {
  state.result.list = param.data.data.products
  state.result.pricingModels = param.data.data.pricing_models
  state.result.count = param.data.data.products_count
  state.result = {...state.result, 'productUnderCategoryCount': param.data.data.product_under_category_counts}
  state.result.page = param.data.data.page.number
  state.result.translations = param.data.data.translations
}

export const setValidateSearchPrice1 = (state, param) => {
  state.search.validatePrice1 = param
}

export const setValidateSearchPrice2 = (state, param) => {
  state.search.validatePrice2 = param
}
export const setCountAllProducts = (state, param) => {
  state.countAll = param
}

export const setSortingProductEditKey = (state, key) => {
  state.sortingEditKey = key
}

export const setProductTabSelected = (state, param) => {
  state.productTabSelected = param
}

export const setCurrentView = (state, param) => {
  state.currentView = param
}

export const setSearchInputClear = (state, param) => {
  state.search.searchInputClear = param
}

export const setAdvanceSearch = (state, param) => {
  if (state.search.advanceSearch === false) {
    state.search.advanceSearch = true
  } else {
    state.search.advanceSearch = false
  }
}

export const setIsSearch = (state, param) => {
  state.search.isSearch = param
}

export const setIsSearchLoading = (state, param) => {
  state.search.isSearchLoading = param
}



// WEBPACK FOOTER //
// ./src/store/modules/products/mutations.js